import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const formHelperText = ({
  spacing,
}: InternalThemeConfig): ComponentsOverrides<Theme>["MuiFormHelperText"] => ({
  root: {
    fontSize: "1.2rem",
    letterSpacing: "0",
    margin: 0,
    marginTop: spacing(0.5),
    fontWeight: 400,
    fontFamily: "RoobertCEZ",
    textTransform: "none",
  },
});

export default formHelperText;
